<template>
  <div>
    <ReportLabelLayout v-if="showConfig" :report="report" :page="page" :orientation="orientation" :page-sizes-mm="pageSizesMm" :page-sizes-loaded="pageSizesLoaded" :start-open="startOpen" @saved="$emit('saved')" />
    <b-card v-if="showPreview" no-body class="reports-design-accordion-card">
      <div class="reports-design-accordion-header" v-b-toggle.label-preview @click="refresh"><AppIcon name="barcode" />Etiqueta<AppIcon name="chevron-down" class="reports-design-accordion-chevron" /></div>
      <b-collapse id="label-preview" :visible="startOpen"><b-card-body>
        <b-button variant="outline-dark" class="pull-right mb-2" size="sm" @click="print"><AppIcon name="printer" class="mr-1" />Imprimir PDF</b-button>
        <EmptyState v-if="content === '[[no-data]]'" icon="barcode" title="No hay productos para previsualizar" description="Marcá productos para impresión o generá las etiquetas desde Productos." />
        <div v-else-if="content" class="crud-reports-design-preview"><iframe :srcdoc="getPreviewContent()" :style="getPreviewIframeStyle()" class="crud-reports-design-preview-html" sandbox title="Vista previa de etiquetas" /></div>
      </b-card-body></b-collapse>
    </b-card>
    <Printer v-if="pdf" :pdf="pdf" />
  </div>
</template>
<script>
import AppIcon from '@/components/inc/icon/AppIcon'
import EmptyState from '@/components/inc/state/EmptyState'
import Printer from '@/components/inc/printer/printer'
import serviceAPI from '../../services'
import ReportLabelLayout from './ReportLabelLayout'
export default {
  name: 'LabelReportDesigner',
  components: { AppIcon, EmptyState, Printer, ReportLabelLayout },
  props: {
    report: { type: Object, required: true }, page: String, orientation: String,
    pageSizesMm: Object, pageSizesLoaded: Boolean, startOpen: { type: Boolean, default: true },
    showConfig: Boolean, showPreview: Boolean
  },
  data: () => ({ content: '', pdf: '' }),
  mounted() { if(this.showPreview && this.startOpen) this.refresh() },
  watch: {
    report() {
      this.content = ''
      this.pdf = ''
      if(this.showPreview) this.refresh()
    }
  },
  methods: {
    getPreviewPageSize() {
      const size = this.pageSizesMm[String(this.page || '').toLowerCase()]
      if(!size) return null
      const width = Number(size.w)
      const height = Number(size.h)
      return String(this.orientation).toLowerCase() === 'landscape'
        ? { width: height, height: width }
        : { width, height }
    },
    getPreviewIframeStyle() {
      const size = this.getPreviewPageSize()
      if(!size) return {}
      return {
        border: '1px solid var(--app-color-border)',
        boxShadow: 'var(--app-shadow-sm)',
        maxWidth: '100%',
        width: size.width + 'mm'
      }
    },
    getPreviewContent() {
      const size = this.getPreviewPageSize()
      if(!size || !this.content) return this.content
      const report = this.report || {}
      const top = Number(report.label_margin_top_mm || 0)
      const left = Number(report.label_margin_left_mm || 0)
      const css = '<style>@media screen { body { box-sizing:border-box !important; width:' + size.width + 'mm !important; height:' + size.height + 'mm !important; padding-top:' + top + 'mm !important; padding-left:' + left + 'mm !important; } }</style>'
      return this.content.replace('</head>', css + '</head>')
    },
    refresh() {
      if(!this.report || !this.report.id) return
      serviceAPI.mostrarRender(this.report.id, 0).then(r => { this.content = r.data }).catch(() => { this.content = '[[no-data]]' })
    },
    print() {
      if(!this.report || !this.report.id) return
      serviceAPI.generate({ reportsID: this.report.id, regID: 0 }).then(r => { this.pdf = r.data }).catch(() => { this.$awn.alert('No se pudieron generar las etiquetas') })
    }
  }
}
</script>
